import {
  SHOW_HISTORY_RECIPE_KEY,
  SHOW_HISTORY_MENU_KEY,
} from '~/constants/localStorageKeys';

export const MAX_HISTORY_COUNT = 20;

type ShowHistoryType = 'recipe' | 'menu';

const STORAGE_KEYS: Record<ShowHistoryType, string> = {
  recipe: SHOW_HISTORY_RECIPE_KEY,
  menu: SHOW_HISTORY_MENU_KEY,
};

/**
 * 閲覧履歴をlocalStorageに保存するcomposable
 */
export function useShowHistory(type: ShowHistoryType) {
  const storageKey = STORAGE_KEYS[type];

  /**
   * IDを閲覧履歴に保存する
   * - 既存のIDがある場合は削除して末尾に追加
   * - 最新20件のみ保持
   * @param id レシピID または 献立ID
   */
  function saveShowHistory(id: number): void {
    // NOTE: クライアントサイドでのみ実行
    if (!import.meta.client) {
      return;
    }

    try {
      // 既存の値を読み込み
      const storedValue = localStorage.getItem(storageKey);
      let storedIds: number[] = [];

      if (storedValue) {
        const parsed = JSON.parse(storedValue);
        if (Array.isArray(parsed)) {
          // 数値のみをフィルタリング
          storedIds = parsed.filter(
            (item): item is number => typeof item === 'number',
          );
        }
      }

      // 同じIDがあれば削除
      storedIds = storedIds.filter((storedId) => storedId !== id);

      // 新しいIDを末尾に追加
      storedIds.push(id);

      // 最新20件のみ保持
      storedIds = storedIds.slice(-MAX_HISTORY_COUNT);

      // localStorageに保存
      localStorage.setItem(storageKey, JSON.stringify(storedIds));
    } catch {
      // NOTE: パースエラーや保存エラーの場合は何もしない
    }
  }

  return {
    saveShowHistory,
  };
}
